import { compose, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import CampaignEmail from '../components/CampaignEmail';
import { fetchCampaign } from '../actions';
import {
  getCampaignLoading,
  getCampaignLogo,
  getCampaignShopName,
  getCampaignShopAddress,
  getCampaignBackgroundImage,
  getCampaignColor,
  getCampaignSubject,
  getCampaignBody,
  getCampaignPromo,
  getCampaignBookUrl,
  getCampaignUnsubscribeUrl,
} from '../selectors';

const CampaignEmailContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      loading: getCampaignLoading(state),
      logo: getCampaignLogo(state),
      shopName: getCampaignShopName(state),
      shopAddress: getCampaignShopAddress(state),
      backgroundImage: getCampaignBackgroundImage(state),
      color: getCampaignColor(state),
      subject: getCampaignSubject(state),
      body: getCampaignBody(state),
      promo: getCampaignPromo(state),
      campaignId: ownProps.params.campaignId,
      source: ownProps.params.source,
      customerId: ownProps.params.customerId,
      bookUrl: getCampaignBookUrl(state),
      unsubscribeUrl: getCampaignUnsubscribeUrl(state),
    }),
    { fetchCampaign },
  ),
  withHandlers({
    fetchCampaign: props => () => props.fetchCampaign(props.campaignId, props.source, props.customerId),
    goToBookAppointment: props => () => (window.location.href = props.bookUrl),
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchCampaign();
    },
  }),
)(CampaignEmail);

export default CampaignEmailContainer;



// WEBPACK FOOTER //
// ./src/app/campaign/containers/CampaignEmail.js